/**
 * Gantt chart export.
 *
 * Thin wrappers over the shared element-image exporter (`@/shared/lib`), kept
 * for the Gantt-specific default filenames and call sites. The capture/PDF
 * logic itself lives in the shared util so the dashboard and other surfaces can
 * reuse it.
 */

import { exportElementToPDF, exportElementToPNG } from '@/shared/lib/export-image';

/** Export Gantt chart to PNG */
export async function exportGanttToPNG(elementId: string, filename = 'gantt-chart.png') {
  return exportElementToPNG(elementId, filename);
}

/** Export Gantt chart to PDF */
export async function exportGanttToPDF(elementId: string, filename = 'gantt-chart.pdf') {
  return exportElementToPDF(elementId, filename);
}
